import { PieceLayoutModel } from "app/piece-layout/models/piece-layout.model";
import { ConcernedPersonModel } from "./concernedPerson.model";
import { HelpPlanTypeModel } from "./help-plan-type.model";
import { IntakeHelpPlansModel } from "./intake-help-plans.model";
import { TravelLegModel } from "./travel-leg.model";

export class HelpPlanDetailsModel {
    hpdId: number;
    hpdCode: string;
    hpdHelpPlanType: HelpPlanTypeModel = null;
    hpdHelpPlan: IntakeHelpPlansModel = null;
    hpdSupplierName: any;
    hpdSupplier: any ;
    hpdSupplierType: any;
    hpdRelationNumber: string;
    hpdPostalCode: string;
    hpdAddress1: string;
    hpdAddress2: string;
    hpdCity: string;
    country: string;
    hpdPhoneNumber: string;
    hpdEmail: string;
    hpdFax: string;
    hdComment: string;
    hdSpecific: any;
    dossierHelpPlanId: string = null;
    parentHelpPlanId: string;
    index: number;
    travelLegList : TravelLegModel[]=[];
    services : any[] = [];
    concernedPersonList : ConcernedPersonModel[]=[];
    orderingDate: Date;
    hpdHelpPlanTypeName: string;
    dhpCreatedDate: Date;
    proformaInvoiceList : PieceLayoutModel[]=[];
    assignmentId: string = null;
    workingOrder : any;
    selectedTravelLegId: string = null;
}